export class DigitalShipmentFilters {
    leastStatusWeight: number;
    greatestStatusWeight: number;
}